<template>
    <div>
        <form v-if="!success" class="form form--two-col form-eh-auth" @submit.prevent @keydown="clearError($event.target.name)" @change="clearError($event.target.name)">                
            <lc-input
                v-model="form.amount"
                label="Amount per paycycle (AU$)"
                name="amount"
                :mask="currencyMask"
                :required="true"
                :errors="form.errors.get('amount')"/>
            <div class="form__action-container">
                <button :disabled="disableBtn" class="button" :class="{'loader loading': loading}" @click.prevent="submitForm()">Submit</button>
            </div>
        </form>
        <transition name="slide">
            <div v-if="success" class="success-message">
                <h2>Success</h2>
                <p>Your authority to deduct from payroll have been submitted.</p>
            </div>
        </transition>
        <p class="ehauth-term"><small>Note: Payments will be made directly to EonX and lodged to your eWallet on Thursday after each pay day. Funds will be available on the following day (Friday).</small></p>
    </div>
</template>
<script>
    import Form from 'utils/Form.js'
    import isEmpty from 'lodash/isEmpty'
    export default {
        name: "EhAuthorityForm",
        data() {
            return {
                loading: false,
                form: new Form({
                    amount: '',
                },
                {
                    amount: 'required',
                }),
                currencyMask: {
                    numeral: true,
                },
                success: false,
            };
        },
        computed: {
            disableBtn() {
                return isEmpty(this.form.amount)
            },
        },
        methods: {
            hideEhAuthorityForm(){
                this.$modal.hide('ehAuthorityForm')
                this.resetForm()
                this.success = false
            },
            clearError(name) {
                this.form.errors.clear(name);
            },
            resetForm(){
                this.form.reset();
            },
            isFormValid(){
                let validator = this.form.validate();
                if(validator.valid) {
                    return true;
                } else {
                    this.form.errors.record(validator.messages)
                    this.$emit('validationFailed')
                    return false;
                }
            },
            submitForm() {
                if(this.isFormValid()){
                    const formatAmount = this.form.amount.replace(/,/g,'')
                    const formData = {
                        amount: formatAmount
                    }
                    this.loading = true
                    this.$store.dispatch('pipeline/postPipeline', {
                        target: 'ehpayslipauth',
                        value: formData
                    }).then(() => {
                        this.loading = false
                        this.success = true
                    }).catch((data) => {
                        this.loading = false
                        this.form.errors.record(data)
                        this.$emit('validationFailed')
                    })
                }
                
            }
        }
    };
</script>
<style lang="scss">
@import 'config';
.form-eh-auth.form--two-col {
    align-items: flex-end;
    .form__container {
        margin-bottom: 0;
    }
    .form__action-container {
        flex: 0 0 auto;
    }
}
.ehauth-term {
    padding-top: 30px;
    font-size: 12px;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/vue/components/forms/EhAuthorityForm.vue